import { render, staticRenderFns } from "./VirtualInfiniteScroll.vue?vue&type=template&id=59834c37&scoped=true&"
import script from "./VirtualInfiniteScroll.vue?vue&type=script&lang=js&"
export * from "./VirtualInfiniteScroll.vue?vue&type=script&lang=js&"
import style0 from "./VirtualInfiniteScroll.vue?vue&type=style&index=0&id=59834c37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59834c37",
  null
  
)

export default component.exports